import React, { useEffect, useState, useCallback } from 'react';
import { Button, Input } from 'antd';
import { UserResponseType } from '../../models/questionnaire.interface';
import { updateSurveyAtom } from '../../store';
import { useAtom } from 'jotai';

const { TextArea } = Input;

interface FreeTextProps {
  questionId: number;
  recordAnswer: (userResponse: UserResponseType) => void;
  isBeingEdited: boolean;
  disabled?: boolean;
}
const FreeText: React.FC<FreeTextProps> = ({
  questionId,
  recordAnswer,
  isBeingEdited,
  disabled = false,
}) => {
  const [interaction] = useAtom(updateSurveyAtom);
  const [typedResponse, setTypedResponse] = useState('');

  useEffect(() => {
    if (isBeingEdited) {
      const previousResponse
        = interaction?.responses.find(
          question => question.questionId === questionId,
        )?.answers?.[0]?.text || '';
      setTypedResponse(previousResponse);
    }
  }, [isBeingEdited]);

  // forces rerender after answering so component doesn't show previous answer text when there are multiple freeText components back to back
  const forceUpdate = useCallback(() => setTypedResponse(''), []);

  const onChange = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
    setTypedResponse(e.target.value);
  };

  const onClick = () => {
    recordAnswer({
      questionId: questionId,
      answers: [{ text: typedResponse }],
    });
    forceUpdate();
  };

  return (
    <div style={{ display: 'flex' }}>
      <TextArea
        placeholder="Enter your response here"
        allowClear
        autoSize
        onChange={onChange}
        maxLength={200}
        value={typedResponse}
        disabled={disabled}
        data-cy="free_text_input"
      />
      <Button
        shape="round"
        style={{ marginLeft: '20px', border: 'none' }}
        disabled={!typedResponse}
        onClick={onClick}
        data-cy="free_text_submit_button"
      >
        Submit
      </Button>
    </div>
  );
};

export default FreeText;
